import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { pageChrono } from './LabelerPrint';
import { CurrentLabelRenderer, PlaceholderLabel } from './labels/LabelRenderer';

export const LabelerPage = (props: { offset?: number; }) => {

    const currentLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);

    if (!currentLabel) return <></>;

    const startingOffset: number = (currentLabel.configuration.labelCountHorizontally * currentLabel.configuration.labelCountVertically) * (props.offset ?? 0);

    const blankStuff = (): React.JSX.Element[] => {
        let inc: number = 0;
        const elements: React.JSX.Element[] = [];
        for (let v = 0; v < currentLabel.configuration.labelCountVertically; v++) {
            const helements: React.JSX.Element[] = [];
            for (let h = 0; h < currentLabel.configuration.labelCountHorizontally; h++) {
                helements.push(<CurrentLabelRenderer key={'label' + inc} offset={startingOffset + inc} />);
                inc++;
            }
            elements.push(<div key={'labelrow' + v}>{helements}</div>);
        }
        return elements;
    };

    return <div className={'label-page-container ' + currentLabel.template.paper.className}><div className={'labeler-page ' + currentLabel.template.paper.className}>{blankStuff()}</div></div>;
};

export const SpecificRowsLabelerPage = (props: { rows: number[], pageGroupName?: string; pageNumber?: number, pageGroupNumber?: number; pageGroupTotal?: number; }) => {

    const currentLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    const sheet = useSelector((state: RootState) => state.labelEditor.currentSheet);

    if (!currentLabel) return <></>;

    const blankStuff = (): React.JSX.Element[] => {

        let inc: number = 0;
        const elements: React.JSX.Element[] = [];
        for (let v = 0; v < currentLabel.configuration.labelCountVertically; v++) {
            const helements: React.JSX.Element[] = [];
            for (let h = 0; h < currentLabel.configuration.labelCountHorizontally; h++) {
                if (inc < props.rows.length) {
                    helements.push(<CurrentLabelRenderer key={'label' + inc} offset={props.rows[inc]} />);
                } else {
                    helements.push(<PlaceholderLabel key={'label' + inc} />);
                }
                inc++;
            }
            elements.push(<div className='printLabelRow' key={'labelrow' + v}>{helements}</div>);
        }
        return elements;
    };

    return <div className={'label-page-container ' + currentLabel.template.paper.className}>
        <div className="centeredContainer">
            {sheet && currentLabel.template.extraVerticalInfos ? <div className="leftLine">{sheet.fileName} _ {sheet.tabName}</div> : null}
            {currentLabel.template.extraVerticalInfos ? <div className="rightLine">{DateTime.now().toLocaleString()} &copy; CONSTRUCTION CDX INC.</div> : null}
        </div>
        {props.pageGroupName ? <div className="pageGroupInfo">GROUPE {props.pageGroupName} {props.pageGroupNumber ? (props.pageGroupTotal ? ' (' + props.pageGroupNumber + ' / ' + props.pageGroupTotal + ')' : ' # ' + props.pageGroupNumber) : ''}</div> : null}
        <div className={'labeler-page ' + currentLabel.template.paper.className}>{blankStuff()}</div>
        {props.pageNumber ? <div className="pageNumber">PAGE {props.pageNumber} / {pageChrono}</div> : null}
    </div>;
};
